/**
 * Asynchronously loads the component for QuotePage
 */

import { lazyLoad } from 'utils/loadable';
import LoadingSpinner from 'app/components/Loading/LoadingSpinner';

export const QuotePage = lazyLoad(
    () => import('./index'),
    module => module.QuotePage,
    { fallback: <LoadingSpinner /> },
);
